// extracted by mini-css-extract-plugin
export default {"prayer-pre-text":"prayer-pre-text--R3TJn","prayerPreText":"prayer-pre-text--R3TJn"};